/**
 * DevExtreme (ui/calendar.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = require("./calendar/ui.calendar");
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/calendar.js
// module id = ../../../../devextreme/ui/calendar.js
// module chunks = common